export const IS_FREE_FLOW_ENABLED =
  true || (typeof window !== 'undefined' && window.location.href.includes('free-flow'));
